// extracted by mini-css-extract-plugin
module.exports = {"Slide":"ActivityCarousel_Slide__3mM87","ActivityCarousel":"ActivityCarousel_ActivityCarousel__31wyT"};